import capitalize from 'src/app/data/common/utils/capitalize';

export function statusFormatter(status?: string) {
  return status ? capitalize(status.replace('_', ' ')) : '';
}
